import { formatDay } from "./billingFormat";

export { invoiceDownloadUrl } from "@/shared/utils/invoiceDownloadUrl";
export { overdueDays, overdueLabel } from "@/shared/utils/overdueDays";

/** Ключ шага карточки платежа в editSchema и в адресе (?tab=payment&id=). */
export const CONTRACT_PAYMENT_CARD_TAB = "payment";

/** Заголовок карточки: номер счёта, а без счёта дата инвойса. */
export function contractPaymentTitle(payment: {
  invoice?: { number: string } | null;
  invoiceDate: string;
}): string {
  if (payment.invoice) return `Счёт ${payment.invoice.number}`;
  return `Платёж от ${formatDay(payment.invoiceDate)}`;
}

/**
 * Адрес карточки платежа. На странице платежей это текущий адрес с
 * tab=payment и id (фильтр и страница сохраняются). Внутри чужого диалога
 * (вкладка платежей организации) нужен cardPath: свои tab и id там заняты
 * организацией.
 */
export function contractPaymentCardHref(
  current: URLSearchParams,
  paymentId: string,
  cardPath?: string
): string {
  if (cardPath) {
    const params = new URLSearchParams({
      tab: CONTRACT_PAYMENT_CARD_TAB,
      id: paymentId,
    });
    return `${cardPath}?${params.toString()}`;
  }
  const next = new URLSearchParams(current);
  next.set("tab", CONTRACT_PAYMENT_CARD_TAB);
  next.set("id", paymentId);
  return `?${next.toString()}`;
}
